<template>
  <v-app dark>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style scoped>
</style>
